export const REACT_APP_BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://dvkn2cf9buvx7.cloudfront.net/api/";
export const REACT_APP_EncryptionKey =
  process.env.REACT_APP_EncryptionKey || "YMpCvPCoH3j4xMs";
